import React from 'react';
import styles from './Footer.module.css'

const Footer = () => {
  return (
    <footer className={styles.footerContainer}>
      © 2025 Deep Algorithms Solutions Pvt Ltd. All Rights Reserved.
    </footer>
  );
};

export default Footer;
